import React, { type ReactElement, type ReactNode } from 'react';

import ColorGlowBackground from '@components/layout/ColorGlowBackground/ColorGlowBackground';

import styles from './InnerContainer.module.scss';

type InnerContainerProps = {
    children: ReactNode;
};

const InnerContainer = ({ children }: InnerContainerProps): ReactElement => {
    return (
        <ColorGlowBackground>
            <div className={styles.container}>{children}</div>
        </ColorGlowBackground>
    );
};

export default InnerContainer;
